var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12231 7.95393C2.12231 7.63352 2.38206 7.37378 2.70247 7.37378H13.1452C13.4656 7.37378 13.7254 7.63352 13.7254 7.95393V11.4348C13.7254 12.3961 12.9461 13.1753 11.9849 13.1753H3.86277C2.90154 13.1753 2.12231 12.3961 2.12231 11.4348V7.95393Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02308 1.57227C5.34349 1.57227 5.60323 1.83201 5.60323 2.15242V2.73257H10.2445V2.15242C10.2445 1.83201 10.5042 1.57227 10.8246 1.57227C11.145 1.57227 11.4048 1.83201 11.4048 2.15242V2.73257H11.9849C12.9461 2.73257 13.7254 3.5118 13.7254 4.47303V5.63333C13.7254 5.95374 13.4656 6.21349 13.1452 6.21349H2.70247C2.38206 6.21349 2.12231 5.95374 2.12231 5.63333V4.47303C2.12231 3.5118 2.90154 2.73257 3.86277 2.73257H4.44293V2.15242C4.44293 1.83201 4.70267 1.57227 5.02308 1.57227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2e0dd1610826509a6cb7d2639b4ba829.svg";
export { ForwardRef as ReactComponent };